module.exports = __webpack_public_path__ + "static/media/sf_1900.4e1766daca04186906b11dd02c196554.png";